<template>
  <CInput
    :autofocus="autofocus"
    class="c-search flex items-center justify-center border-primary5"
    clearable
    :placeholder="placeholder ?? t('canvasUI.components.search.placeholder')"
    show-icon
    :theme-overrides="{
      border: '1px solid var(--p-primary5)',
      placeholderColor: 'var(--p-primary4)',
      textColor: 'var(--p-primary)',
      iconColor: 'var(--p-primary)',
      heightMedium: '32px',
    }"
    :value="search"
    @update:value="(v) => emit('update:search', v)"
  >
    <template #prefix>
      <CIcon class="color-primary" faType="fa" icon="search" size="16px" />
    </template>

    <template #clear-icon>
      <div class="flex w-[1em] h-[1em] font-size-[22px] items-center justify-center rounded-full bg-primary5 my-auto">
        <CIcon class="color-primary" faType="fa" icon="close" size="12px" />
      </div>
    </template>
  </CInput>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CIcon from '@lib/components/CIcon/CIcon.vue'
import CInput from '@lib/components/CInput/CInput.vue'

type Props = {
  autofocus?: boolean
  search?: string
  placeholder?: string
}

defineProps<Props>()

const emit = defineEmits<{
  'update:search': [term: string]
}>()

const { t } = useI18n()
</script>
